<template>
	<div>
		<header-vue></header-vue>
		<!--已写的设备控制接口-->
		<div class="container-l2 container-l4">
			<!--公司及区域选择-->
			<div class="clear text-right">
				<choose-company @event1="changeCom($event)" :areaFlag="areaFlag"></choose-company>
			</div>
			<!--机柜列表-->
			<div class="secNav secNav4">
				<ul>
					<li @click="changeActiveDev(item,index)" :class="{active:activeIndex==index}" v-for="(item,index) in cDevList">
			            <a v-text="item.device_name" href="javascript:void(0);"></a>
			          </li>
				</ul>
			</div>
			<div v-if="ifDetail">
				<!--采集设备类型一数据-->
				<div class="znjg-box">
					<div class="znjg-boxs" v-if="!terminalDetail.dataList">
						<h3>设备详情</h3>
						<p class="p4" v-for="item in terminalDetail">
							<i class="fa fa-dot-circle-o"></i>
							{{item.name}}
							<span class="num" v-text="item.value"></span>
						</p>
					</div>
				</div>
				<!--采集设备类型二数据-->
				<div v-if="terminalDetail.dataList">
					
					<div class="znjg-box">
						<!--环境-->
						<div class="znjg-boxs position-relative">
							<h3>环境详情</h3>
							<!--分设备控制按钮-->
							<div class="control">
								<span 
									v-if="terminalDetail.dataList.fan && terminalDetail.dataList.fan.code=='FAN' && terminalDetail.dataList.fan.operation=='可控'" 
									@click="showFanCon(1)">
									<i class="fa fa-chrome"></i>
									 风扇自动控制
								</span>
								<span 
									v-if="terminalDetail.dataList.fan && terminalDetail.dataList.fan.code=='FAN' && terminalDetail.dataList.fan.operation=='可控'" 
									@click="showFanCon(0)">
									<i class="fa fa-chrome"></i>
									 风扇手动控制
								</span>
								<span
									v-if="terminalDetail.dataList.door && terminalDetail.dataList.door.code=='DOOR' && terminalDetail.dataList.door.operation=='可控'" 
									@click="showPassSet()">
									<i class="fa fa-columns"></i>
									 开门密码设置
								</span>
								<span 
									v-if="terminalDetail.dataList.door && terminalDetail.dataList.door.code=='DOOR' && terminalDetail.dataList.door.operation=='可控' && openDoor==true"
									 @click="showDoorCon()">
									<i class="fa fa-columns"></i>
									 密码开门
								</span>
							</div>
							<div class="znjg-boxs"  v-if="envItem.name"  v-for="(envItem,envKey,index) in terminalDetail.dataList" :key="envKey">
								<p class="title" v-text="envItem.name"></p>
								<p class="p3" v-if="envItem.deviceData" v-for="(envSitem,envSitemKey,index) in envItem.deviceData" :key="envSitemKey">
									<i v-if="envKey=='temperatures'" class="fa fa-globe"></i>
						              <i v-if="envKey=='smokes'" class="fa fa-free-code-camp"></i>
						              <i v-if="envKey=='leakages'" class="fa fa-tint"></i>
						              <i v-if="envKey=='fan'" class="fa fa-ravelry"></i>
						              <i v-if="envKey=='door'" class="fa fa-columns"></i>
						              
									{{envSitem.name}}
									<em>{{envSitem.unit}}</em>
									<span class="num"
					                    :class="{'status danger':envSitem.isHealthy=='N',status:envSitem.value=='正常'}"
					                    v-text="envSitem.value"></span>
								</p>
							</div>
							
						</div>
						<!--机柜内空调、UPS等设备-->
						<div class="znjg-boxs" v-if="!envItem.name"  v-for="(envItem,envKey,index) in terminalDetail.dataList" :key="envKey">
							<div class="znjg-boxs position-relative" v-for="largeItem in envItem">
								<div v-if="largeItem.isHealthy=='Y'">
									<!--分设备控制按钮-->
									<span class="control" v-if="largeItem.code=='LED' && largeItem.operation=='可控'" @click="showLedCon(largeItem)">
										<i class="fa fa-lightbulb-o"></i>
										 LED灯控制
									</span>
									<span class="control" v-if="largeItem.code=='EC03U7' && largeItem.operation=='可控'" @click="shoConCon(largeItem)">
										<i class="fa fa-snowflake-o"></i>
										 空调控制
									</span>
									<span class="control" v-if="largeItem.code=='EVO' && largeItem.operation=='可控'" @click="shoConCon2(largeItem)">
										<i class="fa fa-snowflake-o"></i>
										 空调控制
									</span>	
									<!--新曾消防和电源控制器-->
									<span class="control" v-if="largeItem.code=='FIRECONTROL' && largeItem.operation=='可控'" @click="showFireCon(largeItem)">
										<i class="fa fa-fire-extinguisher"></i>
										 消防控制
									</span>	
									<span class="control" v-if="largeItem.code=='PCON' && largeItem.operation=='可控'" @click="showPowerCon(largeItem)">
										<i class="fa fa-snowflake-o"></i>
										 电源控制
									</span>	
								</div>
								
								
								<h3>{{largeItem.name}}</h3>
								<p class="p3" v-if="largeItem.deviceData" v-for="(largeSitem,largeSitemKey,index) in largeItem.deviceData" :key="largeSitemKey">
									<i class="fa fa-dot-circle-o"></i>
									{{largeSitem.name}}
									<em>{{largeSitem.unit}}</em>
									<span class="num"
					                    :class="{'status danger':largeSitem.isHealthy=='N',status:largeSitem.value=='正常'}"
					                    v-text="largeSitem.value"></span>
								</p>
							</div>
							
						</div>
					</div>
				</div>
				
			</div>
			<div v-if="!ifDetail">
				<p class="text-center dangerp mt60">当前机柜离线或暂无数据！</p>
			</div>
			
		</div>
		<!--风扇手动设置转速-->
		<el-dialog title="设置风扇温度" :visible.sync="fanManFlag" width="500px" >
		    <ul class="fanUl">
		    	<li class="fanLi" v-for="item in fanItemList">
		    		<span class="fanNum" v-text="item.fan_number"></span>
		    		<span class="fanbox">
		    			<p>{{item.current_speed}}</p>
		    			<img v-if="item.current_speed=='关'" src="../../images/iconsignalstate.png"/>
			    		<img v-if="item.current_speed=='低'" src="../../images/iconsignalstateone.png"/>
			    		<img v-if="item.current_speed=='中'" src="../../images/iconsignalstatetwo.png"/>
			    		<img v-if="item.current_speed=='高'" src="../../images/iconsignalstatethree.png"/>
		    		</span>
		    		<span class="fanUp" @click="fanChange(item,2)">∧</span>
		    		<span class="fanDown" @click="fanChange(item,1)">∨</span>
		    		
		    		
		    	</li>
		    </ul>
		</el-dialog>
		<!--风扇设置温度-->
		<el-dialog title="设置风扇温度" :visible.sync="fanAutoFlag" width="500px" >
		    <el-form>
		    	<el-form-item label="请输入要设置的风扇温度">
		    		<el-input type="number" v-model="fanTem" auto-complete="off"></el-input>
			    	
			    </el-form-item>
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="fanAutoFlag=false">取消</el-button>
			    <el-button type="primary" @click="setFanTem()">保存</el-button>
			  </div>
		</el-dialog>
		<!--新曾消防控制-->
		<el-dialog title="消防控制" :visible.sync="fireFlag" width="500px" >
		    <el-form>
		    	<el-form-item label="配电开关" label-width="120px">
		    		<span @click="firePowerSwitchFn()" class="controlSwitch">
		    			<el-switch v-model="firePowerSwitch" disabled></el-switch>
		    		</span>
			    </el-form-item>

				<el-form-item label="电磁阀开关" label-width="120px">
		    		<span @click="fireValveSwitchFn()" class="controlSwitch">
		    			<el-switch v-model="fireValveSwitch" disabled></el-switch>
		    		</span>
			    </el-form-item>

	        	<el-form-item label="声光告警延时" label-width="120px">
			    	<el-input type="number" v-model="fireAlarmDelayed" auto-complete="off"></el-input>
			    </el-form-item>
				<el-form-item label="配电关闭延时" label-width="120px">
			    	<el-input type="number" v-model="firePowerDelayed" auto-complete="off"></el-input>
			    </el-form-item>
				<el-form-item label="电磁阀打开延时" label-width="120px">
			    	<el-input type="number" v-model="fireValveDelayed" auto-complete="off"></el-input>
			    </el-form-item>
				<el-form-item label="气体释放延时" label-width="120px">
			    	<el-input type="number" v-model="fireGasDelayed" auto-complete="off"></el-input>
			    </el-form-item>
				<el-form-item label="温度告警阈值" label-width="120px">
			    	<el-input type="number" v-model="fireAlarmTem" auto-complete="off"></el-input>
			    </el-form-item>
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="fireFlag = false">取消</el-button>
			    <el-button type="primary" @click="setFireParamsFn()">保存</el-button>
			  </div>
		</el-dialog>
		<!--新曾电源控制-->
		<el-dialog title="电源控制" :visible.sync="powerFlag" width="500px" >
		    <el-form>
		    	<el-form-item label="空调开关" label-width="80px">
		    		<span @click="conSwitchFn()" class="controlSwitch">
		    			<el-switch v-model="conSwitch" disabled></el-switch>
		    		</span>
			    	
			    </el-form-item>
	        	<el-form-item label="空调温度" label-width="80px">
			    	<el-input type="number" v-model="conTem" auto-complete="off"></el-input>
			    </el-form-item>
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="conFlag = false">取消</el-button>
			    <el-button type="primary" @click="conTemFn()">保存</el-button>
			  </div>
		</el-dialog>

		<!--EC03U7空调控制-->
		<el-dialog title="空调控制" :visible.sync="conFlag" width="500px" >
		    <el-form>
		    	<el-form-item label="空调开关" label-width="80px">
		    		<span @click="conSwitchFn()" class="controlSwitch">
		    			<el-switch v-model="conSwitch" disabled></el-switch>
		    		</span>
			    	
			    </el-form-item>
	        	<el-form-item label="空调温度" label-width="80px">
			    	<el-input type="number" v-model="conTem" auto-complete="off"></el-input>
			    </el-form-item>
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="conFlag = false">取消</el-button>
			    <el-button type="primary" @click="conTemFn()">保存</el-button>
			  </div>
		</el-dialog>
		<!--3.5KW EVO空调控制-->
		<el-dialog title="空调控制" :visible.sync="conFlag2" width="500px" >
		    <el-form>
		    	<el-form-item label="空调开关" label-width="80px">
		    		<span @click="conSwitchFn()" class="controlSwitch">
		    			<el-switch v-model="conSwitch" disabled></el-switch>
		    		</span>
			    	
			    </el-form-item>
	        	<el-form-item label="空调温度" label-width="80px">
			    	<el-input type="number" v-model="conTem" auto-complete="off"></el-input>
			    </el-form-item>
				<el-form-item label="空调湿度" label-width="80px">
			    	<el-input type="number" v-model="conHum" auto-complete="off"></el-input>
			    </el-form-item>
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="conFlag2 = false">取消</el-button>
			    <el-button type="primary" @click="conTemFn()">保存</el-button>
			  </div>
		</el-dialog>
		<!--开门密码设置-->
		<el-dialog title="开门密码设置" :visible.sync="setPassFlag" width="500px" >
		    <el-form>
		    	<el-form-item label="请输入开门密码">
		    		<el-input type="password" v-model="doorpass" auto-complete="off"></el-input>
			    	
			    </el-form-item>
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="setPassFlag=false">取消</el-button>
			    <el-button type="primary" @click="saveDoorPass()">保存</el-button>
			  </div>
		</el-dialog>
		<!--密码开门-->
		<el-dialog title="密码开门" :visible.sync="doorFlag" width="500px" >
		    <el-form>
		    	<el-form-item label="请输入开门密码">
		    		<el-input type="password" v-model="doorpass" auto-complete="off"></el-input>
			    	
			    </el-form-item>
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="doorFlag=false">取消</el-button>
			    <el-button type="primary" @click="openDoorFn()">开门</el-button>
			  </div>
		</el-dialog>
		<!--LED灯控制-->
		<el-dialog title="LED灯控制" :visible.sync="ledFlag" width="500px" >
		    <el-form>
		    	<el-form-item label="灯控开关" label-width="80px">
		    		<span @click="ledSwitchCon()" class="controlSwitch">
		    			<el-switch v-model="ledSwitch" disabled></el-switch>
		    		</span>
			    	
			    </el-form-item>
	        	<el-form-item label="灯控低温" label-width="80px">
			    	<el-input type="number" v-model="led_low" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="灯控中温" label-width="80px">
			    	<el-input type="number" v-model="led_medium" auto-complete="off"></el-input>
			    </el-form-item>
	            <el-form-item label="灯控高温" label-width="80px">
			    	<el-input type="number" v-model="led_high" auto-complete="off"></el-input>
			    </el-form-item>
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="ledFlag=false">取消</el-button>
			    <el-button type="primary" @click="saveLedCon()">保存</el-button>
			  </div>
		</el-dialog>
	</div>
</template>

<script>
	// import airCondition from './airCondition.vue'
	import chooseCompany from './../comss/chooseCompany.vue'
	export default {
		components: {
		    // airCondition
		    chooseCompany
		   },
		mounted() {
			this.$nextTick(function(){
			
				this.getDeviceList();
				this.getTerminalDetail();
				
		  	})
			//const timer = setInterval(() => {
				//this.getTerminalDetail();
			//}, 10000);

			//this.$once('hook:beforeDestroy', () => {
				//clearInterval(timer);
			//});
			
    	},
    	
    	data(){
    		return{
    			terminalDetail:{},
    			airCondition:[],
    			evoAirCondition:[],
    			cDevList:[],
    			activeDev:{},
    			activeIndex:0,
				selectComId: null,
				selectAreaId: null,   		
    			unbindAdminFlag:false,
    			formLabelWidth:"120px",
    			unbindDevice:{},
    			showLoading:false,
    			administrators:this.getCookie('administrators'),
    			ifDetail:false,
    			ledFlag:false,
    			led_low:null,
				led_medium:null,
				led_high:null,
				ledSwitch:false,
				ledItem:{
					id:null
				},
				areaFlag: true,
				doorFlag:false,
				openDoor:false,
				doorpass:'',
				setPassFlag:false,
				conFlag:false,
				conFlag2:false,
				conSwitch:false,
				conTem:null,
				conHum:null,
				conItem:{
					control_temperature:null,
					id:null
				},
				fanAutoFlag:false,
				fanManFlag:false,
				fanTem:null,
				fanItemList:null,
				current_speed:'关',

				//新曾消防控制器数据
				fireFlag:false,  
				firePowerSwitch:false,
				fireValveSwitch:false,
				fireAlarmDelayed:null,
				firePowerDelayed:null,
				fireValveDelayed:null,
				fireGasDelayed:null,
				fireAlarmTem:null,
				fireItem:null,
                //新曾电源控制器数据
				powerFlag:false,
                powerItem:null,
				timer:null,

				
    		}
    	},
    	methods:{
    		getDeviceList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id:this.selectComId || "",
					packet_id:this.selectAreaId || "",
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
			  		
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/DeviceCabinet/DeviceList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		if(res.data.data.datalist){
		        			this.cDevList = res.data.data.datalist || [];
		        			this.activeDev = this.cDevList[0] || {};
		        			this.checkIfDoor();
		        			this.getTerminalDetail();
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
		  		
			},
			changeCom(data){
				this.selectComId = data.selectComId || "";
				this.selectAreaId = data.selectAreaId || "";
			
			},
			// 选择公司及区域后调用方法
			toChooseCompanyMethod(){
				this.getDeviceList();
			},
			
//			风扇转速
			fanChange(item,num){
//				1减速,2加速
				if(num==1 && item.current_speed == '关'){
					this.$message.warning("风扇已关闭",2000);
				}else if(num==2 && item.current_speed == '高'){
					this.$message.warning("风扇已是最高转速",2000);
				}else{
					this.current_speed = item.current_speed;

					if(num==1){
						if(item.current_speed=='高'){
							item.current_speed = '中';
						}else if(item.current_speed=='中'){
							item.current_speed = '低';
						}else{
							item.current_speed = '关';
						}
					}else{
						if(item.current_speed=='关'){
							item.current_speed = '低';
						}else if(item.current_speed=='低'){
							item.current_speed = '中';
						}else{
							item.current_speed = '高';
						}
					}
					
					let fanDownParams={
						uid:this.getCookie('uid'),
						device_id:this.activeDev.id,
						current_speed:item.current_speed,
						terminalId:4,
						fan_number:item.fan_number
			  		};
			  		this.sign(fanDownParams);
			  		this.$ajax.post(this.$store.state.domain+"/Home/FanCurrentSave/FanCurrentSave",this.$qs.stringify(fanDownParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	if(res.data.status==1){
			        		this.$message.success(res.data.msg,2000);
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			        	}else{
			        		//console.log(res.data.msg);
			        	}
			  		});
				}
				

			},

//			点击风扇自动控制
			showFanCon(num){
//				区分自动和手动控制
				if(num==1){
					this.fanAutoFlag = true;
				}else{
					this.fanManFlag = true;
				}
				
				let changeModeParams={
					uid:this.getCookie('uid'),
					device_id:this.activeDev.id,
					fancontroll:num,
					terminalId:4
		  		};
		  		this.sign(changeModeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/FanStatus/FanStatus",this.$qs.stringify(changeModeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
				
				
				let getFanDetailParams={
					uid:this.getCookie('uid'),
					device_id:this.activeDev.id,
					terminalId:4
		  		};
		  		this.sign(getFanDetailParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/FanList/FanList",this.$qs.stringify(getFanDetailParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.fanTem = res.data.data[1].temperature || null;
		        		this.fanItemList = res.data.data || null;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			保存风扇设置温度
			setFanTem(){
				let setFanTemParams={
					uid:this.getCookie('uid'),
					device_id:this.activeDev.id,
					terminalId:4,
					temperature:this.fanTem,
		  		};
		  		this.sign(setFanTemParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/FanSave/FanSave",this.$qs.stringify(setFanTemParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg,2000);
		        		this.fanAutoFlag = false;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},


//          点击消防控制
            showFireCon(item){
				this.fireItem=item;
				this.fireFlag=true;
				//console.log(item);
				if(item.deviceData){
					//赋值声光告警延时 
					//console.log(item.deviceData.acoustoOpticAlarmDelay);  
					if(item.deviceData.acoustoOpticAlarmDelay){
						this.fireAlarmDelayed=item.deviceData.acoustoOpticAlarmDelay.value || '';
					}
					//赋值配电关闭延时
					if(item.deviceData.distributionClosingDelay){
						this.firePowerDelayed=item.deviceData.distributionClosingDelay.value || '';
					}
					//电磁阀门打开延时
					if(item.deviceData.solenoidValveOpeningDelay){
						this.fireValveDelayed=item.deviceData.solenoidValveOpeningDelay.value || '';
					}
					//气体释放延时                
					if(item.deviceData.gasReleaseDelay){
						this.fireGasDelayed=item.deviceData.gasReleaseDelay.value || '';
					}
					//温度告警阈值
                    if(item.deviceData.temperatureAlarmThreshold){
						this.fireAlarmTem=item.deviceData.temperatureAlarmThreshold.value || '';
					}

					//配电开关
				    if(item.deviceData.distributionStatus.value=='正常'){
						this.firePowerSwitch=true;
					}
					else
					{
						this.firePowerSwitch=false;
					}
					
					//电磁阀开关
					if(item.deviceData.solenoidStatus.value=='打开'){
						this.fireValveSwitch=true;
					}
					else{
						this.fireValveSwitch=false;
					}
					
				}
			},

			//控制消防控制器配电开关
			firePowerSwitchFn(){
				var firePowerSwitchParam;
				//console.log(this.firePowerSwitch);
				if(this.firePowerSwitch == true){
					firePowerSwitchParam = 0;
				}else{
					firePowerSwitchParam = 1;
				}
				
				let fireParams={
					uid:this.getCookie('uid'),
					mount_device_id:this.fireItem.id,
					switch:firePowerSwitchParam
		  		};
		  		this.sign(fireParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AirCondSwitch/AirCondSwitch",this.$qs.stringify(fireParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg,2000);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},

			//控制消防控制器电磁阀开关
			fireValveSwitchFn(){
				var fireValveSwitchParam;
				//console.log(this.fireValveSwitchParam);
				if(this.fireValveSwitch == true){
					fireValveSwitchParam = 0;
				}else{
					fireValveSwitchParam = 1;
				}
				
				let fireParams={
					uid:this.getCookie('uid'),
					mount_device_id:this.fireItem.id,
					switch:fireValveSwitchParam
		  		};
		  		this.sign(fireParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AirCondSwitch/AirCondSwitch",this.$qs.stringify(fireParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg,2000);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},

			//
			setFireParamsFn(){
				let fireParams={
					uid:this.getCookie('uid'),
					mount_device_id:this.fireItem.id,
					acousto:this.fireAlarmDelayed,
					distribution:this.firePowerDelayed,
					solenoid:this.fireValveDelayed,
					gas:this.fireGasDelayed,
					temperature:this.fireAlarmTem
		  		};
		  		this.sign(fireParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/FireSet/FireSet",this.$qs.stringify(fireParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
						this.$message.success(res.data.msg,2000);
						this.fireFlag = false;	
						clearTimeout(this.timer); //清除延迟执行 
						this.timer = setTimeout(()=>{  //设置延迟执行
  							this.getTerminalDetail();
						},10000);					
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commletit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
				  });
			},

			//点击电源控制
			showPowerCon(item){
				this.powerItem=item;
				this.fireFlag=true;
				if(item.devicedata){

				}
			},


//			点击空调控制，EC03U7无水空调
			shoConCon(item){
				this.conItem = item;
				this.conFlag = true;
				if(item.deviceData){
//					赋值温度
					if(item.deviceData.control_temperature){
						this.conTem = item.deviceData.control_temperature.value || '';
					}
//					开关数据处理
					if(item.deviceData.run_status.value=='打开'){
						this.conSwitch = true;
					}else{
						this.conSwitch = false;
					}
				}
				
			},
//			点击空调控制，EVO 3.5KW空调
			shoConCon2(item){
				this.conItem = item;
				this.conFlag2 = true;
				if(item.deviceData){
//					赋值温度
					if(item.deviceData.setting_temperature){
						this.conTem = item.deviceData.setting_temperature.value || '';
					}
					if(item.deviceData.setting_humidity){
						this.conHum = item.deviceData.setting_humidity.value || '';
					}
					
//					开关数据处理
					if(item.deviceData.run_status.value=='正常'){
						this.conSwitch = true;
					}else{
						this.conSwitch = false;
					}
				}
				
			},
//			点击控制空调开关
			conSwitchFn(){
				var conSwitchParam;
				console.log(this.conSwitch);
				if(this.conSwitch == true){
					conSwitchParam = 0;
				}else{
					conSwitchParam = 1;
				}
				
				let conParams={
					uid:this.getCookie('uid'),
					mount_device_id:this.conItem.id,
					switch:conSwitchParam
		  		};
		  		this.sign(conParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AirCondSwitch/AirCondSwitch",this.$qs.stringify(conParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg,2000);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
//			空调温度湿度设置保存
			conTemFn(){
				
				 conParams={
					uid:this.getCookie('uid'),
					mount_device_id:this.conItem.id,
					ctrtemp:this.conTem
		  		};
		  		this.sign(conParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AirCondTemperature/AirCondTemperature",this.$qs.stringify(conParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
						this.$message.success(res.data.msg,2000);
						this.conFlag = false;						
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commletit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
				  });
				  // 判断是否存在湿度，若存在进行保存
				if(this.conFlag2 == true){
					let conHumParams={
						uid:this.getCookie('uid'),
						mount_device_id:this.conItem.id,
						ctrhumi:this.conHum
					};
					this.sign(conHumParams);
					this.$ajax.post(this.$store.state.domain+"/home/AirCondHumi/AirCondHumi",this.$qs.stringify(conHumParams),{
						emulateJSON: true
					}).then(res=>{
						if(res.data.status==1){
							this.$message.success(res.data.msg,2000);
							this.conFlag = false;						
						}else if(res.data.code==10008){
							this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
						}else{
							//console.log(res.data.msg);
							this.$message.error(res.data.msg);
						}
					});
				}
				
				
			},
//			保存开门密码
			saveDoorPass(){
				let saveDoorPassParams={
					uid:this.getCookie('uid'),
					device_id:this.activeDev.id,
					terminalId:4,
					macaddress:this.activeDev.mac_address,
					password:this.doorpass
		  		};
		  		this.sign(saveDoorPassParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/PasswordUpdate/PasswordUpdate",this.$qs.stringify(saveDoorPassParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg,2000);
		        		this.openDoor = true;
		        		this.setPassFlag = false;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			确认开门操作
			openDoorFn(){
				let openDoorFnParams={
					uid:this.getCookie('uid'),
					device_id:this.activeDev.id,
					terminalId:4,
					password:this.doorpass
		  		};
		  		this.sign(openDoorFnParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/PasswordOpen/PasswordOpen",this.$qs.stringify(openDoorFnParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg,2000);
		        		this.doorFlag = false;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg,2000);
		        	}
		  		});
			},

//			查看密码开门是否有密码
			checkIfDoor(){
				let ifDoorParams={
					uid:this.getCookie('uid'),
					device_id:this.activeDev.id,
					terminalId:4
		  		};
		  		this.sign(ifDoorParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/Password/Password",this.$qs.stringify(ifDoorParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.openDoor = true;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			显示开门密码设置
			showPassSet(){
				this.setPassFlag = true;
				this.doorpass = "";
			},
//			显示开门控制
			showDoorCon(){
				this.doorFlag = true;
				this.doorpass = "";
			},
//			显示LED灯控制弹框
			showLedCon(item){
				this.ledFlag = true;
				this.ledItem = item;
				
				if(item.deviceData && item.deviceData.led_low){
					this.led_low = item.deviceData.led_low.value;
					this.led_medium = item.deviceData.led_medium.value;
					this.led_high = item.deviceData.led_high.value;
					if(item.deviceData.led_status.value=='开'){
						this.ledSwitch = true;
					}else{
						this.ledSwitch = false;
					}
				}
			},
//			LED灯开关
			ledSwitchCon(){
				var ledSwitchParam;
				if(this.ledSwitch === true){
					ledSwitchParam = 0;
				}else{
					ledSwitchParam = 1;
				}
				
				let ledParams={
					uid:this.getCookie('uid'),
					device_id:this.activeDev.id,
					led_switch:ledSwitchParam
		  		};
		  		this.sign(ledParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/LedSwitch/LedSwitch",this.$qs.stringify(ledParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg,2000);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
//			LED灯温度设置
			saveLedCon(){
				if(this.led_low<this.led_medium<this.led_high){
					let ledTemParams={
						uid:this.getCookie('uid'),
						device_id:this.activeDev.id,
						led_low:this.led_low,
						led_medium:this.led_medium,
						led_high:this.led_high
			  		};
			  		this.sign(ledTemParams);
			  		this.$ajax.post(this.$store.state.domain+"/Home/LedCtl/LedCtl",this.$qs.stringify(ledTemParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	if(res.data.status==1){
			        		this.$message.success(res.data.msg,2000);
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			        	}else{
			        		//console.log(res.data.msg);
			        		this.$message.error(res.data.msg);
			        	}
			  		});
				}else{
					this.$message.error("温度需从高到低且为数字");
				}
				
			},

    		changeActiveDev(item,index){
    			this.activeIndex = index;
    			this.activeDev = item;
    			this.getTerminalDetail();
    			this.checkIfDoor();
    		},
    		//获取终端详情
    		getTerminalDetail(){
    			this.terminalDetail = {};
    			let valiCodeParams={
					uid:this.getCookie('uid'),
					device_id:this.activeDev.id,
					device_type:this.activeDev.device_type,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/DeviceData/DeviceData",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.ifDetail = true;
		        		this.terminalDetail = res.data.data;
		        		
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        		this.ifDetail = false;
		        	}
		  		});
    		},
    		//运行状态转汉字
    		formatValue(value){
    			
    			switch(parseInt(value)){
    				case 0:
    					return "待机";
    				case 1:
    					return "运行";
    				case 2:
    					return "故障";
    				case 3:
    					return "无效";
    				default:
    					return "异常"
    					
    			}
    		},
    		//风扇速度转汉字
    		formatValue2(value){
    			
    			switch(parseInt(value)){
    				case 0:
    					return "关闭";
    				case 1:
    					return "低速";
    				case 2:
    					return "中速";
    				case 3:
    					return "高速";
    				default:
    					return "异常"
    					
    			}
    		},
    		
    		//处理告警数据
    		formatAlarm(value){
    			var alarmArr = [];
    			alarmArr = value.replace(/(.)(?=[^$])/g, "$1,").split(",")
    			return alarmArr;
    		},
    		//告警状态1
    		fntypeone: function(i) {
				switch (i) {
					case 0:
						return '高温';
					case 1:
						return '内风机';
					case 2:
						return '外风机';
					case 3:
						return '压缩机';
					case 4:
						return '柜内回风温度';
					case 5:
						return '系统高压力';
					case 6:
						return '低温';
					case 7:
						return '直流过压';
				}
			},
			//告警状态2
			fntypetwo: function(i) {
				switch (i) {
					case 0:
						return '直流欠压';
					case 1:
						return '交流过压';
					case 2:
						return '交流欠压';
					case 3:
						return '交流掉电';
					case 4:
						return '蒸发器温度传感器';
					case 5:
						return '冷凝器温度传感器';
					case 6:
						return '环境温度传感器';
					case 7:
						return '蒸发器冻结';
				}
			},
			//告警状态3
			fntypethree: function(i) {
				switch (i) {
					case 0:
						return '频繁高压力';
					case 1:
						return '保留字段';
					case 2:
						return '保留字段';
					case 3:
						return '保留字段';
					case 4:
						return '保留字段';
					case 5:
						return '保留字段';
					case 6:
						return '保留字段';
					case 7:
						return '保留字段';
				}
			},
    	}
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/device/terminalDetail.vue